<template>
<div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
  <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
    <Form ref="MandatureForm" @submit="AddOrganisation" :validation-schema="OrganisationSchema">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group mb-15 mb-sm-20 mb-md-25">
          <label class="d-block text-black fw-semibold mb-10">
            Titre <span class="text-danger">*</span>
          </label>
          <Field name="titre" type="text" class="form-control shadow-none fs-md-15 text-black" />
          <ErrorMessage name="titre" class="text-danger" />
        </div>
      </div>
      <div class="col-md-6 mt-3">
        <div class="form-group mb-15 mb-sm-20 mb-md-25">
          <label class="d-block text-black fw-semibold mb-10">
            Image principale
          </label>
          <input
            type="file"
            accept="image/jpeg,image/png"
            @change="onFileChange"
            class="form-control shadow-none fs-md-15 text-black"
          />


          <ErrorMessage name="image" class="text-danger" />
        </div>
      </div>
    
      <div class="col-md-6">
        <div class="form-group mb-15 mb-sm-20 mb-md-25">
          <label class="d-block text-black fw-semibold mb-10">
            Organisation<span class="text-danger"></span>
          </label>
    
          <Field name="organisation_parent_id" v-slot="{ field }">
          <Multiselect

            :options="OrganisationsOptions"

            :searchable="true"

            track-by="value"

            label="label"

            v-model="selectedParentId"

            placeholder="Sélectionner une organisation parent"

            :can-clear="true"

            @change="field.onChange($event)"

          />
          </Field>
          <ErrorMessage name="organisation_parent_id" class="text-danger" />
        </div>
      </div>
    
      <div class="col-md-6">
        <div class="form-group mb-15 mb-sm-20 mb-md-25">
          <label class="d-block text-black fw-semibold mb-10">
            CategorieArticle<span class="text-danger"></span>
          </label>
          <Field name="categorieId" v-slot="{ field }">
          <Multiselect

            :options="categorieArticlesOptions"

            :searchable="true"

            mode="tags"

            track-by="value"

            label="label"

            v-model="selectedCategorieIds"

            placeholder="Sélectionner des catégories"

            @select="field.onChange(selectedCategorieIds)"

            @remove="field.onChange(selectedCategorieIds)"

          />
          </Field>
          <!-- <ErrorMessage name="categorie_ids" class="text-danger" /> -->
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group mb-15 mb-sm-20 mb-md-25">
          <label class="d-block text-black fw-semibold mb-10">
            Description <span class="text-danger">*</span>
          </label>
          <Field name="description" v-slot="{ field }">
            <QuillEditor
                v-model:content="description"
                contentType="html"
                theme="snow"
                @update:content="field.onChange(description)"
            />
            </Field>
          <ErrorMessage name="description" class="text-danger" />
        </div>
      </div>
      <div class="col-md-12">
        <div class="d-flex align-items-center ">
          <button class="default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success" type="submit">
            Ajouter
          </button>
          <router-link to="/liste-menus" class=" btn btn-danger transition border-0 lh-1 fw-medium">
          <i class="flaticon-delete lh-1 me-1 position-relative top-2"></i>
          <span class="position-relative"></span>Annuler
          </router-link>
        </div>
      </div>
    </div>
    </Form>
</div>
</div>
</template>
 
<script lang="ts">

import { defineComponent, onMounted, ref } from "vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import { useRoute, useRouter } from "vue-router";
import ApiService from "../../services/ApiService";
import * as Yup from "yup";
import Multiselect from '@vueform/multiselect';
import Swal from "sweetalert2";
export default defineComponent({
  name: "AddOrganisation",
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect,

  },
 
  setup: () => {

    const OrganisationSchema = Yup.object().shape({
      titre: Yup.string().required("Le titre est obligatoire"),
      description: Yup.mixed().required("La description est obligatoire"),
      image: Yup.mixed().notRequired(),

    });
 
    const router = useRouter();
    const OrganisationsOptions = ref([]);
    const categorieArticlesOptions = ref([]);
    const selectedParentId = ref<number | null>(null);
    const selectedCategorieIds = ref<number[]>([]);
    const description = ref('');
    const imageInput = ref<HTMLInputElement | null>(null);
    const selectedFile = ref<File | null>(null);

    const onFileChange = (event: Event) => {
      const target = event.target as HTMLInputElement;
      if (target.files && target.files[0]) {
        selectedFile.value = target.files[0];
      }
    };


    const fetchOrganisations = async () => {
      try {
        const response = await ApiService.get('/organisations');
        const organisationsData = response.data.data.data;
        OrganisationsOptions.value = organisationsData.map((organisation) => ({
          value: organisation.id,
          label: `${organisation.titre}`
        }));

      } catch (error) {
        //
      }
    };

    const fetchCategorieArticles = async () => {
      try {
        const response = await ApiService.get('/categorieArticles');
        const categorieData = response.data.data.data;
        const categoriesData = categorieData.filter(
          (categorie: any) => categorie.isService === "Non"
        );
        categorieArticlesOptions.value = categoriesData.map((cat) => ({
          value: cat.id,
          label: `${cat.nom}`,
        }));
      } catch (error) {
        console.error(error);
      }
    };

    const AddOrganisation = async (values: any, { resetForm }) => {
        try {
            const formData = new FormData();

            formData.append("titre", values.titre);
            formData.append("description", values.description);

            //  IMAGE
              if (selectedFile.value) {
                formData.append("urlImage", selectedFile.value); 
              }

            //  ORGANISATION PARENTE
            if (selectedParentId.value) {
            formData.append("organisationId", String(selectedParentId.value));
            }

            //  UNE SEULE CATÉGORIE (OBLIGATOIRE)
            if (selectedCategorieIds.value.length > 0) {
            formData.append("categorieId", String(selectedCategorieIds.value[0]));
            }

            console.log("FormData envoyé :", [...formData.entries()]);

            await ApiService.post("/organisations", formData);

            Swal.fire("Succès", "Organisation créée", "success");
            resetForm();
            router.push("/liste-organisations");

        } catch (error: any) {
            Swal.fire("Erreur", error.response?.data?.message, "error");
        }
    };


    onMounted(() => {
      fetchOrganisations();
      fetchCategorieArticles();

    });
 
    return {
      dropzoneOptions: {
        acceptedFiles: 'image/jpeg,image/png',
      },
      AddOrganisation,
      OrganisationSchema,
      OrganisationsOptions,
      categorieArticlesOptions,
      selectedParentId,
      selectedCategorieIds,
      description,
      onFileChange

    };

  },

});
</script>
<style scoped>
@import 'dropzone-vue/dist/dropzone-vue.common.css';
</style>

 